import { LazyLoadedStates, LazyLoadedStatesManager } from '@edl-development/edl-common';

export const BuildingsLazyLoadedStates = new LazyLoadedStatesManager<{
    base: LazyLoadedStates,
    viewList: LazyLoadedStates,
    viewBuilding: LazyLoadedStates,
    addBuilding: LazyLoadedStates
}> ({
    base: {
        name: 'authenticated.buildings',
        url: '/buildings',
    },
    viewList: {
        name: 'authenticated.buildings.view',
        url: '/view'
    },
    viewBuilding: {
      name: 'authenticated.buildings.viewbuilding',
      url: '/building/:id'
    },
    addBuilding: {
      name: 'authenticated.buildings.addbuilding',
      url: '/building/add'
    }
},
() => import('src/app/buildings/buildings.module').then(mod => mod.BuildingsModule)
);
